(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pf-carousel-card"] && !Shopify.designMode) return;
  try {
    /* Guard: only define if product-card.liquid's JS hasn't loaded them yet */
  if (typeof window.pfQaToggle === 'undefined') {
    window.pfQaToggle = function(btn) {
      var overlay = btn.nextElementSibling;
      if (!overlay || !overlay.classList.contains('pf-variants-overlay')) return;
      if (btn.dataset.singleVariant === 'true') {
        window.pfAddToCart(btn.dataset.variantId, btn, true); return;
      }
      if (/Mobi|Android/i.test(navigator.userAgent)) {
        window.location.href = btn.dataset.productUrl; return;
      }
      var isOpen = overlay.classList.toggle('open');
      btn.style.opacity = isOpen ? '0' : '';
    };

    window.pfAddToCart = function(variantId, btn, isQaBtn) {
      var card = btn.closest('.pf-cc, product-card');
      var qabtn = card ? card.querySelector('.pf-qa-btn') : btn;
      var origText = qabtn ? qabtn.textContent : '+';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (qabtn) { qabtn.textContent = '✓'; qabtn.disabled = true; }
        var overlay = card ? card.querySelector('.pf-variants-overlay') : null;
        if (overlay) { overlay.classList.remove('open'); if (qabtn) qabtn.style.opacity = ''; }
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: c,
              sourceId: String(variantId),
              data: { itemCount: c.item_count }
            }
          }));
        });
        setTimeout(function() { if (qabtn) { qabtn.textContent = origText; qabtn.disabled = false; } }, 1500);
      })
      .catch(function() { if (qabtn) qabtn.textContent = origText; });
    };

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.pf-qa-btn') && !e.target.closest('.pf-variants-overlay')) {
        document.querySelectorAll('.pf-variants-overlay.open').forEach(function(o) {
          o.classList.remove('open');
          var b = o.previousElementSibling;
          if (b && b.classList.contains('pf-qa-btn')) b.style.opacity = '';
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-shipping-timer"] && !Shopify.designMode) return;
  try {
    (function () {
  var AMS_TZ = 'Europe/Amsterdam';

  function getAmsParts(date) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: AMS_TZ,
      weekday: 'short',
      hour: 'numeric',
      hour12: false
    }).formatToParts(date).forEach(function(p) { parts[p.type] = p.value; });
    return parts;
  }

  function buildAmsCutoffUTC(daysForward, cutoffHour) {
    var now = new Date();
    // Amsterdam date as ISO string (YYYY-MM-DD) using sv-SE locale trick
    var iso = now.toLocaleDateString('sv-SE', { timeZone: AMS_TZ });
    var sp = iso.split('-').map(Number);
    // Approximate UTC for cutoffHour on target Amsterdam date
    var approx = new Date(Date.UTC(sp[0], sp[1] - 1, sp[2] + daysForward, cutoffHour, 0, 0));
    // Find Amsterdam hour at that approx UTC to get the real offset
    var amsH = parseInt(new Intl.DateTimeFormat('en-US', {
      timeZone: AMS_TZ, hour: '2-digit', hour12: false
    }).format(approx), 10);
    var offsetH = amsH - cutoffHour;
    if (offsetH > 12)  offsetH -= 24;
    if (offsetH < -12) offsetH += 24;
    return new Date(approx.getTime() - offsetH * 3600000);
  }

  function pfStNext(cutoffHour, shippingDays) {
    var now  = new Date();
    var p    = getAmsParts(now);
    var amsH = parseInt(p.hour, 10);
    var dow  = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(p.weekday);
    if (dow === -1) dow = 0;
    var weekdaysOnly = shippingDays === 'weekdays';
    var DAY_NAMES    = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    function isWd(d) { return d >= 1 && d <= 5; }

    var daysForward, label;

    if (!weekdaysOnly) {
      daysForward = amsH < cutoffHour ? 0 : 1;
      label = daysForward === 0 ? 'today' : 'tomorrow';
    } else {
      if (isWd(dow) && amsH < cutoffHour) {
        daysForward = 0; label = 'today';
      } else {
        daysForward = 1;
        var nDow = (dow + 1) % 7;
        while (!isWd(nDow)) { daysForward++; nDow = (nDow + 1) % 7; }
        label = daysForward === 1 ? 'tomorrow' : DAY_NAMES[nDow];
      }
    }

    return { label: label, target: buildAmsCutoffUTC(daysForward, cutoffHour) };
  }

  function pfStTick(el, cfg) {
    var ship = pfStNext(cfg.cutoffHour, cfg.shippingDays);
    var diff = Math.max(ship.target - new Date(), 0);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var labelEl = el.querySelector('.pf-st-label');
    var cdEl    = el.querySelector('.pf-st-countdown');
    if (labelEl) labelEl.textContent = ship.label;
    if (cdEl)    cdEl.textContent    = h + 'h ' + m + 'm ' + s + 's';
  }

  var SVG_CLOCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
  var SVG_CAL   = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>';

  function pfStInit(el) {
    var bid   = el.dataset.blockId;
    var cfgEl = document.getElementById('pf-st-cfg-' + bid);
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var interval = null;

    function startCd() {
      if (interval) clearInterval(interval);
      pfStTick(el, cfg);
      interval = setInterval(function () { pfStTick(el, cfg); }, 1000);
    }

    function setTimer() {
      if (interval) clearInterval(interval);
      el.classList.remove('pf-ship-timer--preorder', 'pf-ship-timer--hidden');
      el.innerHTML = SVG_CLOCK + '<span class="pf-st-text">Ships <span class="pf-st-label"></span> — order in <strong class="pf-st-countdown pf-st-accent"></strong></span>';
      startCd();
    }

    function setPreorder() {
      if (interval) { clearInterval(interval); interval = null; }
      el.classList.remove('pf-ship-timer--hidden');
      el.classList.add('pf-ship-timer--preorder');
      el.innerHTML = SVG_CAL + '<span class="pf-st-text">' + cfg.restockText + '</span>';
    }

    function setOos() {
      if (interval) { clearInterval(interval); interval = null; }
      el.classList.add('pf-ship-timer--hidden');
    }

    function applyVariant(variantId) {
      var state = cfg.variants[String(variantId)];
      if (!state) return;
      if      (!state.available) { setOos(); }
      else if (state.preorder)   { setPreorder(); }
      else                       { setTimer(); }
    }

    // Initial start (server-side already set the right HTML)
    if (!el.classList.contains('pf-ship-timer--hidden') && !el.classList.contains('pf-ship-timer--preorder')) {
      startCd();
    }

    // Listen for variant changes
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('change', function () {
        var input = form.querySelector('[name="id"]');
        if (input) applyVariant(input.value);
      });
    });

    // Dawn / theme custom event
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) applyVariant(e.detail.variant.id);
    });

    // URL-based variant pickers
    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search).get('variant');
      if (p) applyVariant(p);
    });
  }

  function pfStBootstrap() {
    document.querySelectorAll('.pf-ship-timer[data-block-id]').forEach(pfStInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pfStBootstrap);
  } else {
    pfStBootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('.pf-ship-timer[data-block-id]').forEach(pfStInit);
  });
  document.addEventListener('shopify:block:load', function (e) {
    if (e.target) e.target.querySelectorAll('.pf-ship-timer[data-block-id]').forEach(pfStInit);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pf-stock-level"] && !Shopify.designMode) return;
  try {
    (function () {
  function pfSlInit(el) {
    var bid   = el.dataset.blockId;
    var cfgEl = document.getElementById('pf-sl-cfg-' + bid);
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    function applyVariant(variantId) {
      var v = cfg.variants[String(variantId)];
      if (!v) return;

      var show = !v.preorder && v.available && v.managed && v.stock > 0 && v.stock <= cfg.threshold;

      el.classList.toggle('pf-stock-level--hidden', !show);

      if (show) {
        var pct  = Math.min(100, (v.stock / cfg.threshold) * 100).toFixed(1);
        var fill = el.querySelector('.pf-sl-fill');
        var cnt  = el.querySelector('.pf-sl-count');
        if (fill) fill.style.width = pct + '%';
        if (cnt)  cnt.textContent  = v.stock;
      }
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('change', function () {
        var input = form.querySelector('[name="id"]');
        if (input) applyVariant(input.value);
      });
    });

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) applyVariant(e.detail.variant.id);
    });

    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search).get('variant');
      if (p) applyVariant(p);
    });
  }

  function pfSlBootstrap() {
    document.querySelectorAll('.pf-stock-level[data-block-id]').forEach(pfSlInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pfSlBootstrap);
  } else {
    pfSlBootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('.pf-stock-level[data-block-id]').forEach(pfSlInit);
  });
  document.addEventListener('shopify:block:load', function (e) {
    if (e.target) e.target.querySelectorAll('.pf-stock-level[data-block-id]').forEach(pfSlInit);
  });
}());
  } catch(e) { console.error(e); }
})();

})();
